/* eslint-disable react/prop-types */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Loading from 'assets/images/loading.png';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import { makeStyles } from '@mui/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import {
  Pendingwarning,
  Redwarning,
} from 'component/BuyersMarketplace/MakeOffers';
import { ADD_PROPERTY_CAMPAIGN } from 'constant/app.config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import {
  checkbox_style,
  pick_date,
  select_dropdown_retrex,
  typography_textfield,
} from './PropertyCreation.style';
import Swal from 'sweetalert2';
import { AGENT_NOTIFICATION_TO_BUYER } from 'constant/app.config';
dayjs.extend(utc);
dayjs.extend(timezone);
const todayInSydney = dayjs(
  dayjs().tz('Australia/Sydney').format('YYYY-MM-DD')
);

// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// const useStyles = makeStyles({
//   root: {
//     "& .MuiButtonBase": {
//       border: 0,
//       borderRadius: 3,
//       color: "red",
//       fontFamily:'Poppins !important',
//       fontSize: 24,
//     },
//   },
// });

export const ToggleOff = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.459961"
        y="0.370483"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="#DFDFDF"
      />
      <ellipse
        cx="12.981"
        cy="12.5557"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
    </svg>
  );
};
export const ToggleOn = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.460938"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="url(#paint0_linear_9124_97512)"
      />
      <ellipse
        cx="30.0913"
        cy="12.1852"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9124_97512"
          x1="12.7341"
          y1="-1.66162"
          x2="18.2578"
          y2="28.3495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default function RetrexCampaign({
  value,
  setValue,
  onClose,
  // moxoagentack,
  // moxovendorack,
  publishcard,
  unpublishcard,
  activityfun,
  ismediacompleted,
  fromHeader,
  resumeTempId,
  pendingTab,
  dashboardcount,
  pipelineTempId,
}) {
  const theme = useTheme();
  const matches389 = useMediaQuery(theme.breakpoints.down(389));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [thistabfunc, setThistabfunc] = useState(false);
  const [status, setStatus] = useState('');
  const [campaignType, setCampaignType] = useState('');
  const [depositAmount, setDepositAmount] = useState('');
  const [settlementDays, setSettlementDays] = useState('');
  const [startDate, setStartdate] = useState('');
  const [starttime, setStarttime] = useState('');
  const [enddate, setEnddate] = useState('');
  const [endtime, setEndtime] = useState('');
  const [acceptalloffers, setAcceptalloffers] = useState(false);
  const [unconditional, setUnconditional] = useState(true);
  const [offerAcceptance, setOfferAcceptance] = useState(false);
  const [stage2OfferAcceptance, setStage2OfferAcceptance] = useState(true);
  const [verifiedbuyers, setVerifiedbuyers] = useState(false);
  const [st1minoffer, setSt1minoffer] = useState('');
  const [st2minoffer, setSt2minoffer] = useState('');
  const [timerreset, setTimerreset] = useState(30);
  const [timerresetpopup, setTimerresetpopup] = useState(false);
  const [lessthanstage2, setLessthanstage2] = useState(false);
  const [stageTwoTimerReset, setStageTwoTimerReset] = useState('');
  const [error, setError] = useState(false);
  const [errorStageOneMinOffer, setErrorStageOneMinOffer] = useState(false);
  const [errorStageTwoMinOffer, setErrorStageTwoMinOffer] = useState(false);
  const [errorTimer, setErrorTimer] = useState(false);
  const [errorStageTwoTimer, setErrorStageTwoTimer] = useState(false);
  const [isSelectFocusedCampaignType, setSelectFocusedCampaignType] =
    useState(false);
  const [isSelectDepositAmount, setSelectDepositAmount] = useState(false);
  const [isSelectSettleDate, setSelectSettleDate] = useState(false);
  const [isSelectFocusedTimer, setSelectFocusedTimer] = useState(false);
  const [isSelectStageTwoFocusedTimer, setSelectStageTwoFocusedTimer] =
    useState(false);
  const [isSelectoffersharefocus, setSelectoffersharefocus] = useState(false);
  const [isSelectoffersharetimefocus, setSelectoffersharetimefocus] =
    useState(false);
  const [isSelectFocusedStage1, setSelectFocusedStage1] = useState(false);
  const [isSelectFocusedStage2, setSelectFocusedStage2] = useState(false);
  const [errorMessageStatus, setErrorMessageStatus] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageDeposit, setErrorMessageDeposit] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageSettle, setErrorMessageSettle] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageStartDate, setErrorMessageStartDate] = useState(false);
  const [errorMessageEndingDate, setErrorMessageEndingDate] = useState(false);
  const [errorMessageEndTime, setErrorMessageEndTime] = useState(false);
  const [errorMessageStartTime, setErrorMessageStartTime] = useState(false);
  const publishstatusref = useRef(null);
  const startdateref = useRef(null);
  const starttimeref = useRef(null);
  const enddateref = useRef(null);
  const endtimeref = useRef(null);
  const minofferst1ref = useRef(null);
  const minofferst2ref = useRef(null);
  const stage2durationref = useRef(null);
  const timerresetref = useRef(null);
  const depositAmountRef = useRef(null);
  const settlementDaysRef = useRef(null);
  const [errorMessageTimer, setErrorMessageTimer] = useState({
    helperText: '',
    error: false,
  });
  const [errorMessageoffersharingtime, setErrorMessageoffersharingtime] =
    useState({
      helperText: '',
      error: false,
    });
  const [confirmStage2Modal, setConfirmStage2Modal] = useState(false);
  const [overrideText, setOverrideText] = useState('');
  const [isOverrideValid, setIsOverrideValid] = useState(false);
  const [overrideError, setOverrideError] = useState(false);
  const [currentSydneyDate, setCurrentSydneyDate] = useState(
    dayjs().tz('Australia/Sydney')
  );
  const [currentSydneyTime, setCurrentSydneyTime] = useState(false);

  const minDate = currentSydneyDate;

  const [agentack, setAgentack] = useState([]);
  const [vendorack, setVendorack] = useState([]);

  let propertyId =
    fromHeader == 'no' &&
    resumeTempId != 0 &&
    resumeTempId != undefined &&
    pendingTab == 4
      ? resumeTempId
      : localStorage.getItem('propertyId');
  // let propertyId=localStorage.getItem('propertyId')
  const handleOverrideTextChange = (event) => {
    const value = event.target.value;
    setOverrideText(value);

    if (value === 'override') {
      setIsOverrideValid(true);
    } else {
      setIsOverrideValid(false);
    }

    if (value.trim() !== '') {
      setOverrideError(false);
    }
  };

  const handleStage2OfferAcceptance = (event) => {
    const isChecked = event.target.checked;
    if (!isChecked) {
      setConfirmStage2Modal(true);
    } else {
      setStage2OfferAcceptance(true);
    }
  };

  const handleCloseStage2ConfirmModal = () => {
    setOverrideText('');
    setOverrideError(false);
    setConfirmStage2Modal(false);
  };

  const handleConfirmDisableStage2 = () => {
    if (overrideText.trim() === '') {
      setOverrideError(true);
      return;
    }

    setOverrideError(false);

    setStage2OfferAcceptance(false);
    setConfirmStage2Modal(false);
  };

  const [confirmModal, setConfirmModal] = useState(false);

  const handleOpenConfirmModal = () => {
    let today = dayjs().tz('Australia/Sydney').format('YYYY-MM-DD');

    if (campaignType === '') {
      setErrorMessageStatus({
        helperText: 'Please fill this field',
        error: true,
      });
      publishstatusref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageStatus({
        helperText: '',
        error: false,
      });
    }
    if (startDate === '') {
      setErrorMessageStartDate('Select start date');
      startdateref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageStartDate('');
    }

    if (enddate && enddate < startDate) {
      setErrorMessageEndingDate('End date cannot be before start date');
      startdateref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageStartDate('');
    }

    if (startDate && !dayjs(startDate).isValid()) {
      setErrorMessageStartDate('Date format should be DD-MM-YYYY');
      startdateref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageStartDate('');
    }

    if (startDate < today) {
      setErrorMessageStartDate('Date cannot be in past');
      startdateref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageStartDate('');
    }

    if (starttime === '') {
      setTimeout(() => {
        starttimeref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      setErrorMessageStartTime('Select start time');
      return;
    } else {
      setErrorMessageStartTime('');
    }

    if (
      startDate == dayjs().tz('Australia/Sydney').format('YYYY-MM-DD') &&
      starttime < currentSydneyDate.format('HH:mm')
    ) {
      setTimeout(() => {
        starttimeref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      setErrorMessageStartTime('Time cannot be in past');
      return;
    } else {
      setErrorMessageStartTime('');
    }

    if (enddate == startDate) {
      setTimeout(() => {
        enddateref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      setErrorMessageEndingDate(
        'Start date and end date must be atleast one day apart'
      );
      return;
    } else {
      setErrorMessageEndingDate('');
    }

    if (enddate === '') {
      setTimeout(() => {
        enddateref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      setErrorMessageEndingDate('Select End date');
      return;
    } else {
      setErrorMessageEndingDate('');
    }
    if (enddate < startDate) {
      setTimeout(() => {
        enddateref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      setErrorMessageEndingDate('End date cannot be before start date');
      return;
    } else {
      setErrorMessageEndingDate('');
    }
    if (enddate && !dayjs(enddate).isValid()) {
      setTimeout(() => {
        enddateref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      setErrorMessageEndingDate('Date format should be DD-MM-YYYY');
      return;
    } else {
      setErrorMessageEndingDate('');
    }

    if (endtime === '') {
      setTimeout(() => {
        endtimeref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 100);
      setErrorMessageEndTime('Select end time');
      return;
    } else {
      setErrorMessageEndTime('');
    }
    if (stage1 === '') {
      setErrorStageOneMinOffer(true);
      minofferst1ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    if (stage2 === '') {
      setErrorStageTwoMinOffer(true);
      minofferst2ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    if (stageTwoTimer === '') {
      setErrorMessageTimer({
        helperText: 'Stage 2 duration not set',
        error: true,
      });
      stage2durationref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageTimer({
        helperText: '',
        error: false,
      });
    }
    if (timer === '') {
      setErrorTimer(true);
      timerresetref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    }
    if (depositAmount === '' || !/^\d{1,4}%$/.test(depositAmount)) {
      setErrorMessageDeposit({
        helperText: 'Enter a valid deposit amount in %',
        error: true,
      });
      depositAmountRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageDeposit({
        helperText: '',
        error: false,
      });
    }
    if (settlementDays === '' || !/^\d{1,3}$/.test(settlementDays)) {
      setErrorMessageSettle({
        helperText: 'Enter a valid number for Settlement Days',
        error: true,
      });
      settlementDaysRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return;
    } else {
      setErrorMessageSettle({
        helperText: '',
        error: false,
      });
    }

    setConfirmModal(true);
  };
  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);
  const handleCloseConfirmModal = () => {
    setConfirmModal(false);
  };
  const handleChange1 = (event) => {
    // setStatus(event.target.value);
    setErrorMessageStatus({
      helperText: '',
      error: false,
    });
    setCampaignType(event.target.value);
  };

  const handleDeposit = (e) => {
    let input = e.target.value.replace(/\D/g, '');
    const numericValue = parseInt(input, 10);
    if (numericValue === 0) return;
    if (isNaN(numericValue) || numericValue < 0) {
      setDepositAmount('');
      setErrorMessageDeposit({ error: false });
      return;
    }
    if (numericValue > 100) {
      setErrorMessageDeposit({ error: false });
    } else {
      setDepositAmount(`${numericValue}%`);
      setErrorMessageDeposit({ error: false });
    }
    setTimeout(() => {
      const inputElement = document.getElementById('deposit-amount');
      if (inputElement) {
        inputElement.setSelectionRange(
          inputElement.value.length - 1,
          inputElement.value.length - 1
        );
      }
    }, 0);
  };

  const handleSettleDay = (e) => {
    const input = e.target.value.replace(/\D/g, '');
    const numericValue = parseInt(input, 10);
    if (numericValue === 0) return;
    if (input.length <= 3) {
      setSettlementDays(input);
      setErrorMessageSettle({ error: false });
    } else {
      setErrorMessageSettle({ error: true });
    }
  };

  const [stage1, setStage1] = useState('');
  const handleChange2 = (event) => {
    setErrorStageOneMinOffer(false);
    setStage1(event.target.value);
    setSt1minoffer(event.target.value);
  };
  const [stage2, setStage2] = useState('');

  const handleChange3 = (event) => {
    setErrorStageTwoMinOffer(false);
    setStage2(event.target.value);
    setSt2minoffer(event.target.value);
  };
  const defaultTime = new Date();
  defaultTime.setHours(0);
  defaultTime.setMinutes(30);

  const [timer, setTimer] = useState(dayjs().set('hour', 0).set('minute', 30));
  const [offersharingtime, setOffersharingtime] = useState(0);
  const [stageTwoTimer, setStageTwoTimer] = useState('');
  const handleChange4 = (event) => {
    setErrorTimer(false);
    setTimer(event.target.value);
    setTimerreset(event.target.value);
  };
  const handleChange5 = (event) => {
    const newStage2 = event.target.value;

    setErrorMessageTimer({ helperText: '', error: false });
    setErrorStageTwoTimer(false);
    setStageTwoTimer(newStage2);
    setStageTwoTimerReset(newStage2);

    if (timerreset > newStage2 * 60) {
      setTimerresetpopup(true);
      setLessthanstage2(true);
    } else if (timerreset > 360) {
      setTimerresetpopup(true);
      setLessthanstage2(false);
    } else {
      setTimerresetpopup(false);
      setLessthanstage2(false);
    }
  };
  const handleChange7 = (event) => {
    setErrorMessageoffersharingtime({
      helperText: '',
      error: false,
    });
    setOffersharingtime(event.target.value);
  };
  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const handleAsyncOperation = async (funcvalue, inputData) => {
    const skipMediaCompleted =
      fromHeader === 'no' && resumeTempId !== 0 && resumeTempId !== undefined;

    const isNotEmptyArray = (arr) =>
      Array.isArray(arr) &&
      arr.length > 0 &&
      !arr.every((item) => Array.isArray(item) && item.length === 0);

    if (
      (skipMediaCompleted || ismediacompleted) &&
      (thistabfunc || funcvalue)
    ) {
      try {
        setLoading(false);
        onClose();
        setValue(0);
        publishcard();
        unpublishcard();
        activityfun();

        // let propertyId = localStorage.getItem('propertyId');
        postApiCall(AGENT_NOTIFICATION_TO_BUYER, { propertyId });
        if (isNotEmptyArray(inputData?.dataForVendorAck)) {
          await Moxoseparationinlisting(
            'dataForVendorAck',
            inputData?.dataForVendorAck
          );
        }
        if (isNotEmptyArray(inputData?.dataForAgentAck)) {
          await Moxoseparationinlisting(
            'dataForAgentAck',
            inputData?.dataForAgentAck
          );
        }
      } catch (error) {
        console.error('Error in async operation:', error);
        setLoading(false); // Handle error by stopping the loader if necessary
      }
    }
  };

  useEffect(() => {
    handleAsyncOperation();
  }, [ismediacompleted]);

  const [publishStatusRecentlySelected, setPublishStatusRecentlySelected] =
    useState(false);
  const [
    stOneMinimumOfferRecentlySelected,
    setStOneMinimumOfferRecentlySelected,
  ] = useState(false);
  const [
    stTwoMinimumOfferRecentlySelected,
    setStTwoMinimumOfferRecentlySelected,
  ] = useState(false);
  const [offerSharingRecentlySelected, setOfferSharingRecentlySelected] =
    useState(false);
  const [stageTwoTimerRecentlySelected, setStageTwoTimerRecentlySelected] =
    useState(false);

  // Publish Status

  const PublishStatusHandleOpen = () => {
    if (!publishStatusRecentlySelected) {
      setSelectFocusedCampaignType(true);
    }
  };
  const PublishStatusHandleclose = () => {
    setSelectFocusedCampaignType(false);
    setPublishStatusRecentlySelected(true);
    setTimeout(() => {
      setPublishStatusRecentlySelected(false);
    }, 100);
  };

  // Minimum Offer Increments St1

  const StageOneMinimumOfferHandleOpen = () => {
    if (!stOneMinimumOfferRecentlySelected) {
      setSelectFocusedStage1(true);
    }
  };
  const StageOneMinimumOfferHandleclose = () => {
    setSelectFocusedStage1(false);
    setStOneMinimumOfferRecentlySelected(true);
    setTimeout(() => {
      setStOneMinimumOfferRecentlySelected(false);
    }, 100);
  };

  // Minimum Offer Increments St2

  const StageTwoMinimumOfferHandleOpen = () => {
    if (!stTwoMinimumOfferRecentlySelected) {
      setSelectFocusedStage2(true);
    }
  };
  const StageTwoMinimumOfferHandleclose = () => {
    setSelectFocusedStage2(false);
    setStTwoMinimumOfferRecentlySelected(true);
    setTimeout(() => {
      setStTwoMinimumOfferRecentlySelected(false);
    }, 100);
  };

  // Offer Sharing

  const OfferSharingHandleOpen = () => {
    if (!offerSharingRecentlySelected) {
      setSelectoffersharetimefocus(true);
    }
  };
  const OfferSharingHandleclose = () => {
    setSelectoffersharetimefocus(false);
    setOfferSharingRecentlySelected(true);
    setTimeout(() => {
      setOfferSharingRecentlySelected(false);
    }, 100);
  };

  // Stage 2 timer

  const StageTwoTimerHandleOpen = () => {
    if (!stageTwoTimerRecentlySelected) {
      setSelectStageTwoFocusedTimer(true);
    }
  };
  const StageTwoTimerHandleclose = () => {
    setSelectStageTwoFocusedTimer(false);
    setStageTwoTimerRecentlySelected(true);
    setTimeout(() => {
      setStageTwoTimerRecentlySelected(false);
    }, 100);
  };

  const Campaign = async (optionalValue) => {
    setLoading(true);
    // let propertyId = localStorage.getItem('propertyId');
    const DepositAmount = depositAmount.replace('%', '');

    const formattedStartTime = starttime
      ? dayjs(starttime, 'HH:mm').format('HH:mm')
      : '00:00';
    const formattedEndTime = endtime
      ? dayjs(endtime, 'HH:mm').format('HH:mm')
      : '23:59';

    const params = {
      propertyId: propertyId,
      campaignType: campaignType,
      campaignStart: startDate,
      campaignStartTime: formattedStartTime,
      campaignEnd: enddate,
      campaignEndTime: formattedEndTime,
      stageTwoTime: stageTwoTimer,
      offerSharing: offersharingtime,
      offerAccShare: offerAcceptance == false ? '0' : '1',
      isAutoStage2: stage2OfferAcceptance == false ? '0' : '1',
      depositAmount: DepositAmount,
      settlementDays: settlementDays,
      reasonForDisableAutoStage2: overrideText ? overrideText : '',
      campaignStartDateOptional: optionalValue,
      stageOne: {
        UnconditionalOnly: acceptalloffers == false ? '0' : '1',
        MinimumIncrement: st1minoffer,
      },
      stageTwo: {
        UnconditionalOnly: unconditional == false ? '0' : '1',
        VerifiedBuyers: verifiedbuyers == false ? '0' : '1',
        MinimumIncrement: st2minoffer,
        TimerReset: timerreset,
        stage2Timer: stageTwoTimer,
      },
    };

    try {
      const res = await postApiCall(ADD_PROPERTY_CAMPAIGN, params);
      if (res.data.status == -1) {
        if (optionalValue === '0') {
          Swal.fire({
            title: 'Confirm Action',
            html: `
    <div style="font-family: poppins; text-align: left;">
      <p style="font-size: 16px; margin-bottom: 10px;">
        You have selected a campaign start date and time that is later than the auction date and time.
      </p>
      <p style="font-size: 16px; margin-top: 10px;">
        Are you sure you want to do this?
      </p>
    </div>
  `,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            reverseButtons: true,
            didOpen: () => {
              [Swal.getConfirmButton(), Swal.getCancelButton()].forEach(
                (button) => {
                  button?.style.setProperty('width', '80px', 'important');
                  button?.style.setProperty('min-width', '80px', 'important');
                  button?.style.setProperty('max-width', '80px', 'important');
                  button?.style.setProperty('flex', '0 0 80px', 'important');
                  button?.style.setProperty(
                    'box-sizing',
                    'border-box',
                    'important'
                  );
                  button?.style.setProperty('padding', '8px 0', 'important');
                }
              );
            },
          }).then((result) => {
            if (result.isConfirmed) {
              Campaign('1');
            }
          });
        } else {
          toast.error(res.data.message, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: 0,
            theme: 'light',
            style: {
              fontFamily: 'Poppins', // 👈 Inline Poppins font
            },
          });
          dashboardcount?.();
        }

        setLoading(false);
        dashboardcount?.();
        return;
      }
      dashboardcount?.();
      setThistabfunc(true);
      handleAsyncOperation('true', res?.data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const [imageUrl, setImageUrl] = useState(null);
  const Dateicon = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 2V5"
          stroke="#200E32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 2V5"
          stroke="#200E32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.5 9.08984H20.5"
          stroke="#200E32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
          stroke="#200E32"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.6937 13.6992H15.7027"
          stroke="#200E32"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.6937 16.6992H15.7027"
          stroke="#200E32"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.9945 13.6992H12.0035"
          stroke="#200E32"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.9945 16.6992H12.0035"
          stroke="#200E32"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.29529 13.6992H8.30427"
          stroke="#200E32"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.29529 16.6992H8.30427"
          stroke="#200E32"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const Timeicon = () => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.51496 1.01896C8.34401 1.00635 8.17225 1 8 1V0C8.19685 0 8.39314 0.00726199 8.58852 0.0216722L8.51496 1.01896ZM10.5193 1.46905C10.1985 1.34533 9.86912 1.2454 9.53371 1.17008L9.75282 0.194382C10.1361 0.280463 10.5126 0.394665 10.8792 0.536055L10.5193 1.46905ZM11.889 2.17971C11.7458 2.08402 11.5994 1.99388 11.4503 1.90939L11.9432 1.0393C12.1136 1.13586 12.2809 1.23888 12.4446 1.34824C12.6082 1.4576 12.7674 1.5727 12.9219 1.69322L12.3066 2.48158C12.1715 2.37612 12.0322 2.27541 11.889 2.17971ZM13.7231 3.96934C13.5252 3.68829 13.3068 3.42218 13.0697 3.17321L13.794 2.48368C14.0649 2.76821 14.3145 3.07233 14.5407 3.39353L13.7231 3.96934ZM14.4672 5.32122C14.4012 5.16208 14.3296 5.00583 14.2526 4.85271L15.1458 4.40311C15.2339 4.5781 15.3157 4.75667 15.391 4.93853C15.4664 5.12039 15.5348 5.30453 15.5962 5.49054L14.6467 5.80423C14.5929 5.64147 14.5331 5.48035 14.4672 5.32122ZM14.9979 7.82822C14.9895 7.48455 14.9557 7.14197 14.8969 6.80326L15.8822 6.63231C15.9494 7.01939 15.988 7.41092 15.9976 7.80367L14.9979 7.82822ZM14.8655 9.36563C14.8991 9.1967 14.9264 9.02699 14.9474 8.85687L15.9398 8.97929C15.9159 9.17372 15.8847 9.36766 15.8463 9.56072C15.8079 9.75378 15.7625 9.94489 15.7102 10.1337L14.7464 9.867C14.7922 9.70179 14.8319 9.53457 14.8655 9.36563ZM13.914 11.745C14.0979 11.4546 14.2602 11.151 14.3995 10.8367L15.3137 11.2419C15.1545 11.6011 14.969 11.9481 14.7588 12.28L13.914 11.745ZM12.9497 12.9497C13.0715 12.828 13.1885 12.702 13.3005 12.5722L14.0577 13.2254C13.9297 13.3737 13.796 13.5177 13.6569 13.6569L12.9497 12.9497Z"
          fill="#212529"
        />
        <path
          d="M8 1C6.84885 1 5.71545 1.2839 4.70022 1.82655C3.68499 2.3692 2.81926 3.15386 2.17971 4.11101C1.54017 5.06816 1.14654 6.16827 1.03371 7.31388C0.920876 8.45949 1.09232 9.61525 1.53285 10.6788C1.97337 11.7423 2.66939 12.6808 3.55925 13.4111C4.44911 14.1414 5.50533 14.6409 6.63437 14.8655C7.76341 15.0901 8.93041 15.0327 10.032 14.6986C11.1336 14.3644 12.1358 13.7637 12.9497 12.9497L13.6569 13.6569C12.7266 14.5871 11.5812 15.2736 10.3223 15.6555C9.06332 16.0374 7.72961 16.1029 6.43928 15.8463C5.14895 15.5896 3.94183 15.0187 2.92486 14.1841C1.90788 13.3495 1.11243 12.2769 0.608966 11.0615C0.105504 9.846 -0.0904279 8.52514 0.0385242 7.21586C0.167476 5.90659 0.617333 4.64933 1.34825 3.55544C2.07916 2.46155 3.06857 1.5648 4.22883 0.94463C5.38909 0.324457 6.68439 0 8 0V1Z"
          fill="#212529"
        />
        <path
          d="M7.5 3C7.77614 3 8 3.22386 8 3.5V8.70984L11.2481 10.5659C11.4878 10.7029 11.5711 11.0083 11.4341 11.2481C11.2971 11.4878 10.9917 11.5711 10.7519 11.4341L7.25193 9.43412C7.09615 9.3451 7 9.17943 7 9V3.5C7 3.22386 7.22386 3 7.5 3Z"
          fill="#212529"
        />
      </svg>
    );
  };
  const handleToggle1Change = () => {
    setAcceptalloffers(!acceptalloffers);
  };

  const handleOfferAcceptanceChange = () => {
    setOfferAcceptance(!offerAcceptance);
  };

  const handleToggle2Change = () => {
    setUnconditional(!unconditional);
  };

  const handleToggle3Change = () => {
    setVerifiedbuyers(!verifiedbuyers);
  };
  const isSmallScreen = useMediaQuery(
    '(min-width:900px) and (max-width:930px)'
  );
  return (
    <form
      ref={formRef}
      style={{ marginBottom: '40px' }}
      onSubmit={(e) => {
        e.preventDefault(); // 🚫 stop page refresh
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          const active = document.activeElement;
          // if Enter pressed inside an input (not the submit button) → block
          if (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA') {
            e.preventDefault();
          }

          // if Enter pressed while the submit button is focused → trigger it manually
          if (active.type === 'button' && active.innerText === 'Submit') {
            e.preventDefault();
            active.click(); // ✅ simulate button click
          }
        }
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography className={classes.PropertyTitle}>
            Campaign Configuration
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <FormControl style={{ display: 'flex' }}>
            <FormLabel sx={typography_textfield} variant="h6" required>
              Publish Status
            </FormLabel>
            <InputLabel
              focused={false}
              shrink={false}
              variant="h4"
              htmlFor="campaignType-count-select"
              sx={{
                marginTop: matchessm ? '25px' : '35px',
                marginLeft: '20px',
                fontFamily: 'poppins',
                color: 'rgba(0, 0, 0, 0.34)',
                fontWeight: 300,
                visibility:
                  campaignType || isSelectFocusedCampaignType
                    ? 'hidden'
                    : 'visible',
              }}
            >
              Campaign Type
            </InputLabel>
            <Select
              required
              inputProps={{
                id: 'campaignType-count-select',
              }}
              ref={publishstatusref}
              fullWidth
              disableUnderline
              helperText={errorMessageStatus.helperText}
              error={errorMessageStatus.error}
              sx={
                (select_dropdown_retrex,
                {
                  fontFamily: 'poppins',
                  marginTop: '13px',
                  '.MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(0, 85, 255, 0.64)',
                  },
                })
              }
              IconComponent={ExpandMoreIcon}
              value={campaignType}
              onChange={handleChange1}
              open={isSelectFocusedCampaignType}
              onClose={PublishStatusHandleclose}
              onFocus={PublishStatusHandleOpen}
              onMouseDown={(event) => {
                PublishStatusHandleOpen();
              }}
              onBlur={() => setSelectFocusedCampaignType(false)}
            >
              {/* <MenuItem
                          sx={{
                            fontFamily: "Poppins !important",
                            fontSize: "16px",
                            fontWeight: "300",
                          }}
                          value={1}
                          disabled
                        >
                          CampaignType
                        </MenuItem> */}

              <MenuItem
                sx={{
                  fontFamily: 'Poppins !important',
                  fontSize: '16px',
                  fontWeight: '300',
                }}
                value={'Online'}
              >
                Online
              </MenuItem>
              <MenuItem
                sx={{
                  fontFamily: 'Poppins !important',
                  fontSize: '16px',
                  fontWeight: '300',
                }}
                value={'Off Market'}
              >
                Off Market
              </MenuItem>
            </Select>
          </FormControl>
          {errorMessageStatus.error && (
            <FormHelperText style={{ color: '#d32f2f' }}>
              Select campaign type
            </FormHelperText>
          )}
        </Grid>
        {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}></Grid> */}

        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <FormLabel sx={typography_textfield} variant="h6" required>
            Start Date
          </FormLabel>
          <div style={{ marginTop: '5px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker', 'DatePicker']}>
                <DatePicker
                  // label="Pick Date"
                  sx={
                    (pick_date,
                    {
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    })
                  }
                  inputProps={{
                    style: {
                      fontFamily: 'Poppins',
                    },
                    required: true,
                  }}
                  ref={startdateref}
                  minDate={todayInSydney}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!errorMessageStartDate,
                      helperText: errorMessageStartDate,
                    },
                  }}
                  format="DD-MM-YYYY"
                  value={startDate ? dayjs(startDate) : null}
                  onChange={(newValue) => {
                    if (!newValue || !newValue.isValid()) {
                      setErrorMessageStartDate(
                        'Date format should be DD-MM-YYYY'
                      );
                      return;
                    }
                    const val = newValue.format('YYYY-MM-DD');
                    setStartdate(val);
                    const today = dayjs()
                      .tz('Australia/Sydney')
                      .format('YYYY-MM-DD');
                    if (val < today) {
                      setErrorMessageStartDate('Date cannot be in past');
                      return;
                    }
                    if (val == today) {
                      setCurrentSydneyTime(true);
                      setStarttime(dayjs(minDate).format('HH:mm'));
                      if (
                        starttime &&
                        starttime < currentSydneyDate.format('HH:mm')
                      ) {
                        setErrorMessageStartTime('Time cannot be in past');
                      }
                    } else {
                      setCurrentSydneyTime(false);
                    }
                    // Handle end date check
                    if (
                      enddate &&
                      enddate < dayjs(val).add(1, 'day').format('YYYY-MM-DD')
                    ) {
                      setEnddate('');
                      setErrorMessageStartDate('');
                      setErrorMessageEndingDate(
                        'End date cleared: must be at least one day after the start date'
                      );
                    } else {
                      setErrorMessageStartTime('');
                      setErrorMessageStartDate('');
                    }
                  }}
                  slots={{
                    openPickerIcon: Dateicon,
                  }}
                  ampm={false}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
          {/* {errorMessageStartDate && (
              <FormHelperText style={{ color: "#d32f2f"}}>
                 {errorMessageStartDate}
              </FormHelperText>
            )} */}
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <FormLabel sx={typography_textfield} variant="h6" required>
            Start Time
          </FormLabel>
          <div style={{ marginTop: '5px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['TimePicker', 'TimePicker']}>
                <TimePicker
                  slotProps={{
                    textField: {
                      placeholder: 'hh:mm',
                      fullWidth: true,
                      error: !!errorMessageStartTime,
                      helperText: errorMessageStartTime,
                    },
                  }}
                  ref={starttimeref}
                  timeSteps={{ hours: 1, minutes: 1 }}
                  fullWidth
                  sx={
                    (pick_date,
                    {
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    })
                  }
                  // label="Pick Time"
                  views={['hours', 'minutes']}
                  minTime={
                    currentSydneyTime
                      ? dayjs(currentSydneyDate.format('HH:mm'), 'HH:mm')
                      : null
                  }
                  value={
                    starttime
                      ? dayjs(starttime, 'HH:mm')
                      : currentSydneyTime
                      ? dayjs(currentSydneyDate.format('HH:mm'), 'HH:mm')
                      : null
                  }
                  // onChange={(newValue) => {
                  //   setStarttime(newValue);
                  // }}
                  onChange={(newValue) => {
                    if (newValue && newValue.isValid()) {
                      const formattedTime = newValue.format('HH:mm');
                      setStarttime(formattedTime);
                      setErrorMessageStartTime('');
                      if (
                        startDate ==
                          dayjs().tz('Australia/Sydney').format('YYYY-MM-DD') &&
                        formattedTime < currentSydneyDate.format('HH:mm')
                      ) {
                        setErrorMessageStartTime('Time cannot be in past');
                      } else {
                        setErrorMessageStartTime('');
                      }
                    } else {
                      setStarttime('');
                      setErrorMessageStartTime('Time format should be HH:MM');
                    }
                  }}
                  slots={{
                    openPickerIcon: Timeicon,
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
          {/* {errorMessageStartTime && (
              <FormHelperText style={{ color: "#d32f2f"}}>
                Select start time
              </FormHelperText>
            )} */}
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <FormLabel sx={typography_textfield} variant="h6" required>
            End Date
          </FormLabel>
          <div style={{ marginTop: '5px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker', 'DatePicker']}>
                <DatePicker
                  required
                  // label="Pick Date"
                  sx={
                    (pick_date,
                    {
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    })
                  }
                  ref={enddateref}
                  minDate={
                    startDate ? dayjs(startDate).add(1, 'day') : todayInSydney
                  }
                  format="DD-MM-YYYY"
                  value={enddate ? dayjs(enddate) : null}
                  onChange={(newValue) => {
                    let val = newValue.format('YYYY-MM-DD');
                    setEnddate(val);
                    if (newValue && newValue.isValid()) {
                      if (val == startDate) {
                        setErrorMessageEndingDate(
                          'Start date and end date must be at least one day apart'
                        );
                      } else if (val < startDate) {
                        setErrorMessageEndingDate(
                          'End date cannot be before start date'
                        );
                      } else {
                        setErrorMessageEndingDate('');
                      }
                    } else {
                      setErrorMessageEndingDate(
                        'Date format should be DD-MM-YYYY'
                      );
                    }
                  }}
                  // onChange={(newValue) => {
                  //   let val = newValue ? newValue.format("YYYY-MM-DD") : null;
                  //   setEnddate(val);
                  // }}
                  slots={{
                    openPickerIcon: Dateicon,
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!errorMessageEndingDate,
                      helperText: errorMessageEndingDate,
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
          {/* {errorMessageEndingDate && (
              <FormHelperText style={{ color: "#d32f2f"}}>
                Select End date
              </FormHelperText>
            )} */}
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <FormLabel sx={typography_textfield} variant="h6" required>
            End Time
          </FormLabel>
          <div style={{ marginTop: '5px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['TimePicker', 'TimePicker']}>
                <TimePicker
                  slotProps={{
                    textField: {
                      placeholder: 'hh:mm',
                      fullWidth: true,
                      error: !!errorMessageEndTime,
                      helperText: errorMessageEndTime,
                    },
                  }}
                  fullWidth
                  sx={
                    (pick_date,
                    {
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    })
                  }
                  ref={endtimeref}
                  views={['hours', 'minutes']}
                  value={endtime ? dayjs(endtime, 'HH:mm') : null}
                  // onChange={(newValue) => {
                  //   setEndtime(newValue);
                  // }}
                  onChange={(newValue) => {
                    if (newValue && newValue.isValid()) {
                      const formattedTime = newValue.format('HH:mm');
                      setEndtime(formattedTime);
                      setErrorMessageEndTime('');
                    } else {
                      setEndtime('');
                      setErrorMessageEndTime('Time format should be HH:MM');
                    }
                  }}
                  slots={{
                    openPickerIcon: Timeicon,
                  }}
                  // ampm={false}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
          {/* {errorMessageEndTime && (
              <FormHelperText style={{ color: "#d32f2f"}}>
                Select end time
              </FormHelperText>
            )} */}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography className={classes.PropertyTitle}>
            Offer Status
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <button tabIndex="-1" className={classes.PropertyButton}>
            STAGE 1
          </button>
          <br />
        </Grid>
        <Grid
          className={classes.stage1colour}
          sx={{ marginLeft: { xs: '15px' } }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Stack flexDirection="row">
              <Typography>
                <input
                  type="checkbox"
                  checked={acceptalloffers}
                  onChange={handleToggle1Change}
                />
              </Typography>
              <Typography sx={checkbox_style}>
                &nbsp; Unconditional Offers Only
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormControl style={{ display: 'flex', marginTop: '8px' }}>
              <FormLabel sx={typography_textfield} variant="h6" required>
                Minimum Offer Increments
              </FormLabel>

              <Grid item xs={12} md={6}>
                <InputLabel
                  focused={false}
                  shrink={false}
                  variant="h4"
                  htmlFor="stage1-count-select"
                  sx={{
                    fontFamily: 'poppins',
                    // marginTop: matches389?"65px":"35px",
                    marginTop: { xs: '28px', md: '35px' },
                    marginLeft: '20px',
                    color: 'rgba(0, 0, 0, 0.34)',
                    fontWeight: 300,
                    visibility:
                      stage1 || isSelectFocusedStage1 ? 'hidden' : 'visible',
                  }}
                >
                  {/* Define minimum increase for each new offer */}
                  Min increase for each offer
                </InputLabel>
                <Select
                  inputProps={{
                    id: 'stage1-count-select',
                  }}
                  required
                  fullWidth
                  ref={minofferst1ref}
                  disableUnderline
                  helperText={errorStageOneMinOffer}
                  error={errorStageOneMinOffer}
                  sx={
                    (select_dropdown_retrex,
                    {
                      fontFamily: 'poppins',
                      marginTop: '10px',
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    })
                  }
                  IconComponent={ExpandMoreIcon}
                  value={stage1}
                  onChange={handleChange2}
                  open={isSelectFocusedStage1}
                  onClose={StageOneMinimumOfferHandleclose}
                  onFocus={StageOneMinimumOfferHandleOpen}
                  onMouseDown={(event) => {
                    StageOneMinimumOfferHandleOpen();
                  }}
                  onBlur={() => setSelectFocusedStage1(false)}
                >
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={100}
                  >
                    $100
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={200}
                  >
                    $200
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={300}
                  >
                    $300
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={500}
                  >
                    $500
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={1000}
                  >
                    $1,000
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={5000}
                  >
                    $5,000
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={10000}
                  >
                    $10,000
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={20000}
                  >
                    $20,000
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={25000}
                  >
                    $25,000
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={50000}
                  >
                    $50,000
                  </MenuItem>
                </Select>
              </Grid>
            </FormControl>
            {errorStageOneMinOffer && (
              <FormHelperText style={{ color: '#d32f2f', marginTop: '5px' }}>
                Select minimum offer increase amount
              </FormHelperText>
            )}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={3}>
              <FormLabel sx={typography_textfield} variant="h6" required>
                Offer Sharing
              </FormLabel>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <FormLabel sx={typography_textfield} variant="h6">
                  Automatically Broadcast Offers to the Market Place
                </FormLabel>
                <InputLabel
                  focused={false}
                  shrink={false}
                  variant="h4"
                  htmlFor="timer-count-select"
                  sx={{
                    fontFamily: 'poppins',
                    marginTop: '35px',
                    marginLeft: '20px',
                    visibility: 'hidden',
                  }}
                >
                  Choose any option
                </InputLabel>
                <Select
                  required
                  fullWidth
                  inputProps={{
                    id: 'timer-count-select',
                  }}
                  disableUnderline
                  ref={stage2durationref}
                  helperText={errorMessageoffersharingtime.helperText}
                  error={errorMessageoffersharingtime.error}
                  sx={
                    (select_dropdown_retrex,
                    {
                      fontFamily: 'poppins',
                      marginLeft: '20px',
                      width: 'auto',
                      paddingX: '10px',
                      marginTop: '10px',
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    })
                  }
                  IconComponent={ExpandMoreIcon}
                  value={offersharingtime}
                  onChange={handleChange7}
                  open={isSelectoffersharetimefocus}
                  onClose={OfferSharingHandleclose}
                  onFocus={OfferSharingHandleOpen}
                  onMouseDown={(event) => {
                    OfferSharingHandleOpen();
                  }}
                  onBlur={() => setSelectoffersharetimefocus(false)}
                >
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={0}
                  >
                    Instantly
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={1}
                  >
                    After 1 Hour
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={8}
                  >
                    After 8 Hours
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={24}
                  >
                    After 24 Hours
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={48}
                  >
                    After 48 Hours
                  </MenuItem>
                </Select>
              </FormControl>
              <Stack
                flexDirection={'row'}
                alignItems={'center'}
                mt={'18px'}
                gap={2}
              >
                <input
                  type="checkbox"
                  checked={offerAcceptance}
                  onChange={handleOfferAcceptanceChange}
                />
                <Typography sx={typography_textfield}>
                  Automatically Broadcast Offers to the MarketPlace after Offer
                  Acceptance
                </Typography>
              </Stack>
              {errorMessageoffersharingtime.error && (
                <FormHelperText style={{ color: '#d32f2f', marginTop: '5px' }}>
                  {errorMessageoffersharingtime.helperText}
                </FormHelperText>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <button tabIndex="-1" className={classes.PropertyButton2}>
            STAGE 2 - FINAL OFFERS
          </button>
        </Grid>
        <Grid
          className={classes.stage2colour}
          sx={{ marginLeft: { xs: '15px' } }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Stack flexDirection={'row'}>
                <Typography>
                  <input
                    type="checkbox"
                    checked={unconditional}
                    onChange={handleToggle2Change}
                  />
                </Typography>
                <Typography sx={checkbox_style}>
                  &nbsp; Unconditional Offers Only
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Stack flexDirection={'row'}>
                <Typography>
                  <input
                    type="checkbox"
                    checked={verifiedbuyers}
                    onChange={handleToggle3Change}
                  />
                </Typography>
                <Typography sx={checkbox_style}>
                  &nbsp; Verified Buyers Only
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}></Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <FormControl style={{ display: 'flex' }}>
                <FormLabel
                  sx={{
                    ...typography_textfield,
                    fontSize: isSmallScreen
                      ? '19px'
                      : typography_textfield.fontSize,
                    marginTop: '7px',
                  }}
                  variant="h6"
                  required
                >
                  Minimum Offer Increments
                </FormLabel>
                <InputLabel
                  focused={false}
                  shrink={false}
                  variant="h4"
                  htmlFor="stage2-count-select"
                  sx={{
                    fontFamily: 'poppins',
                    // marginTop: matches389?"65px":"35px",
                    marginTop: { xs: '35px', md: '40px' },
                    marginLeft: '20px',
                    color: 'rgba(0, 0, 0, 0.34)',
                    fontWeight: 300,
                    zIndex: 1,
                    visibility:
                      stage2 || isSelectFocusedStage2 ? 'hidden' : 'visible',
                  }}
                >
                  {/* Define minimum increase for each new offer */}
                  Min increase for each offer
                </InputLabel>
                <Select
                  required
                  inputProps={{
                    id: 'stage2-count-select',
                  }}
                  fullWidth
                  disableUnderline
                  ref={minofferst2ref}
                  helperText={errorStageTwoMinOffer}
                  error={errorStageTwoMinOffer}
                  sx={
                    (select_dropdown_retrex,
                    {
                      fontFamily: 'poppins',
                      marginTop: '10px',
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    })
                  }
                  IconComponent={ExpandMoreIcon}
                  value={stage2}
                  onChange={handleChange3}
                  open={isSelectFocusedStage2}
                  onClose={StageTwoMinimumOfferHandleclose}
                  onFocus={StageTwoMinimumOfferHandleOpen}
                  onMouseDown={(event) => {
                    StageTwoMinimumOfferHandleOpen();
                  }}
                  onBlur={() => setSelectFocusedStage2(false)}
                >
                  {/* <MenuItem
                            sx={{
                              fontFamily: "Poppins !important",
                              fontSize: "16px",
                              fontWeight: "300",
                            }}
                            value={1}
                            disabled
                          >
                            Select
                          </MenuItem> */}
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={100}
                  >
                    $100
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={200}
                  >
                    $200
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={300}
                  >
                    $300
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={500}
                  >
                    $500
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={1000}
                  >
                    $1,000
                  </MenuItem>
                </Select>
              </FormControl>
              {errorStageTwoMinOffer && (
                <FormHelperText style={{ color: '#d32f2f', marginTop: '5px' }}>
                  Select minimum offer increase amount
                </FormHelperText>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <FormControl style={{ display: 'flex' }}>
                <FormLabel
                  sx={{ ...typography_textfield, marginTop: '7px' }}
                  variant="h6"
                  required
                >
                  Stage 2 Timer
                </FormLabel>
                <InputLabel
                  focused={false}
                  shrink={false}
                  variant="h4"
                  htmlFor="timer-count-select"
                  sx={{
                    fontFamily: 'poppins',
                    marginTop: { xs: '35px', md: '40px' },
                    marginLeft: '20px',
                    color: 'rgba(0, 0, 0, 0.34)',
                    fontWeight: 300,
                    visibility:
                      stageTwoTimer || isSelectStageTwoFocusedTimer
                        ? 'hidden'
                        : 'visible',
                  }}
                >
                  Minimum time for Stage 2
                </InputLabel>
                <Select
                  required
                  fullWidth
                  inputProps={{
                    id: 'timer-count-select',
                  }}
                  disableUnderline
                  ref={stage2durationref}
                  helperText={errorMessageTimer.helperText}
                  error={errorMessageTimer.error}
                  sx={
                    (select_dropdown_retrex,
                    {
                      fontFamily: 'poppins',
                      marginTop: '10px',
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 85, 255, 0.64)',
                      },
                    })
                  }
                  IconComponent={ExpandMoreIcon}
                  value={stageTwoTimer}
                  onChange={handleChange5}
                  open={isSelectStageTwoFocusedTimer}
                  onClose={StageTwoTimerHandleclose}
                  onFocus={StageTwoTimerHandleOpen}
                  onMouseDown={(event) => {
                    StageTwoTimerHandleOpen();
                  }}
                  onBlur={() => setSelectStageTwoFocusedTimer(false)}
                >
                  {/* <MenuItem
                            sx={{
                              fontFamily: "Poppins !important",
                              fontSize: "16px",
                              fontWeight: "300",
                            }}
                            value={1}
                            disabled
                          >
                            Select
                          </MenuItem> */}

                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={4}
                  >
                    4 hours
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={6}
                  >
                    6 hours
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontSize: '16px',
                      fontWeight: '300',
                    }}
                    value={24}
                  >
                    24 hours
                  </MenuItem>
                </Select>
              </FormControl>
              {errorMessageTimer.error && (
                <FormHelperText style={{ color: '#d32f2f', marginTop: '5px' }}>
                  {errorMessageTimer.helperText}
                </FormHelperText>
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={4}
              onClick={() => {
                if (stageTwoTimer != '') {
                  setErrorMessageTimer({
                    helperText: '',
                    error: false,
                  });
                } else {
                  setErrorMessageTimer({
                    helperText: 'Stage 2 duration not set',
                    error: true,
                  });
                }
              }}
            >
              <FormControl fullWidth sx={{ display: 'flex' }}>
                <FormLabel
                  sx={{
                    ...typography_textfield,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    marginTop: '7px',
                    marginBottom: '10px',
                  }}
                  variant="h6"
                  required
                >
                  Timer Reset
                  <span
                    style={{
                      fontFamily: 'poppins',
                      fontSize: '16px',
                    }}
                  >
                    (hh:mm)
                  </span>
                </FormLabel>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={['TimePicker', 'TimePicker']}
                    sx={{
                      paddingTop: 0,
                      '& .MuiPickersLayout-root': {
                        width: '100%',
                      },
                    }}
                  >
                    <TimePicker
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: errorTimer,
                          helperText: errorTimer,
                          inputProps: {
                            readOnly: true,
                          },
                          sx: {
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: errorTimer
                                  ? '#d32f2f'
                                  : 'rgba(0, 85, 255, 0.64)',
                              },
                              '&:hover fieldset': {
                                borderColor: errorTimer
                                  ? '#d32f2f'
                                  : 'rgba(0, 85, 255, 0.64)',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: errorTimer
                                  ? '#d32f2f'
                                  : 'rgba(0, 85, 255, 0.64)',
                              },
                            },
                            '& .MuiInputBase-root': {
                              height: '56px',
                            },
                          },
                        },
                      }}
                      sx={{
                        width: '100%',
                        '.MuiInputBase-input': {
                          fontFamily: 'poppins',
                        },
                      }}
                      ref={timerresetref}
                      views={['hours', 'minutes']}
                      value={timer}
                      minTime={dayjs().set('hour', 0).set('minute', 15)}
                      disableOpenPicker={stageTwoTimer == '' ? true : false}
                      onAccept={(newValue) => {
                        if (newValue) {
                          let val = moment(new Date(newValue)).format('HH:mm');
                          const [hours, minutes] = val.split(':').map(Number);
                          const totalMinutes = hours * 60 + minutes;
                          setTimer(newValue);
                          setTimerreset(totalMinutes);
                          if (stageTwoTimer * 60 < totalMinutes) {
                            setTimerresetpopup(true);
                            setLessthanstage2(true);
                          } else {
                            if (totalMinutes > 360) {
                              setTimerresetpopup(true);
                              setLessthanstage2(false);
                            } else {
                              setTimerresetpopup(false);
                              setLessthanstage2(false);
                            }
                          }
                        } else {
                          setTimer(null);
                          setTimerreset(30);
                        }
                      }}
                      slots={{
                        openPickerIcon: Timeicon,
                      }}
                      ampm={false}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                {errorTimer && (
                  <FormHelperText
                    style={{ color: '#d32f2f', marginTop: '5px' }}
                  >
                    Stage 2 timer reset value missing
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Stack
              flexDirection={'row'}
              alignItems={'center'}
              mt={'18px'}
              gap={2}
            >
              <input
                type="checkbox"
                checked={stage2OfferAcceptance}
                onChange={handleStage2OfferAcceptance}
              />
              <Typography sx={typography_textfield}>
                Automatically commence Stage 2 once Offer & Acceptance is
                received
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography className={classes.PropertyTitle}>
            Conditional Terms
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <FormControl style={{ display: 'flex' }}>
            <FormLabel sx={typography_textfield} variant="h6" required>
              Deposit Amount
            </FormLabel>
            <TextField
              required
              id="deposit-amount"
              variant="outlined"
              fullWidth
              inputRef={depositAmountRef}
              value={depositAmount}
              onChange={handleDeposit}
              error={errorMessageDeposit.error}
              placeholder="Deposit Amount"
              inputProps={{
                maxLength: 4,
              }}
              sx={{
                fontFamily: 'Poppins',
                marginTop: '10px',
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(0, 85, 255, 0.64)',
                },
              }}
              onFocus={() => setSelectDepositAmount(true)}
              onBlur={() => setSelectDepositAmount(false)}
            />
          </FormControl>
          {errorMessageDeposit.error && (
            <FormHelperText style={{ color: '#d32f2f' }}>
              Enter Deposit Amount
            </FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <FormControl style={{ display: 'flex' }}>
            <FormLabel sx={typography_textfield} variant="h6" required>
              Settlement Days
            </FormLabel>
            <TextField
              required
              id="settlement-days"
              variant="outlined"
              fullWidth
              inputRef={settlementDaysRef}
              value={settlementDays}
              onChange={handleSettleDay}
              error={errorMessageSettle.error}
              placeholder="Settlement days"
              inputProps={{
                maxLength: 3,
              }}
              sx={{
                fontFamily: 'Poppins',
                marginTop: '10px',
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(0, 85, 255, 0.64)',
                },
              }}
              onFocus={() => setSelectSettleDate(true)}
              onBlur={() => setSelectSettleDate(false)}
            />
          </FormControl>
          {errorMessageSettle.error && (
            <FormHelperText style={{ color: '#d32f2f' }}>
              Enter Settlement days
            </FormHelperText>
          )}
        </Grid>

        <Dialog
          open={confirmStage2Modal}
          onClose={handleCloseStage2ConfirmModal}
          maxWidth="md"
          PaperProps={{
            sx: {
              width: matchessm ? '100%' : 'auto',
              m: matchessm ? 0 : 2,
            },
          }}
          fullWidth
        >
          <DialogTitle
            sx={{
              fontFamily: 'Poppins',
              fontSize: matches450 ? '16px' : '24px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Pendingwarning /> &nbsp; Disable Automatic Stage 2 Commencement
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              You have limited Stage 2 to unconditional offers only.
              <br />
              <br />
              By disabling the Automatic Commence Stage 2 option, once Offer and
              Acceptance is received you will have to commence Stage 2 manually.
              This means at the time you, must select each buyer to participate
              and confirm the start time.
              <br />
              <br />
              After Offer and Acceptance is received, any new conditional offers
              will be blocked.
              <br />
              <br />
              <strong>NOT RECOMMEND</strong> - Manual handling causes delays
              increasing the risk of losing buyers.
              <br />
              <br />
              <Box
                display="flex"
                flexDirection={matchessm ? 'column' : 'row'}
                alignItems={matchessm ? 'flex-start' : 'center'}
                gap={1}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    whiteSpace: matchessm ? 'normal' : 'nowrap',
                    width: matchessm ? '100%' : 'auto',
                  }}
                >
                  Type override to proceed:
                  <span style={{ color: 'red' }}> *</span>
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: matchessm ? '100%' : 'auto',
                    flexGrow: matchessm ? 0 : 1,
                  }}
                >
                  <TextField
                    multiline
                    type="text"
                    value={overrideText}
                    onChange={handleOverrideTextChange}
                    placeholder="Type override to proceed"
                    rows={5}
                    sx={{
                      flexGrow: 1,
                      fontSize: '16px',
                      fontFamily: 'Poppins',
                      width: matchessm ? '100%' : 'auto',
                      flexGrow: matchessm ? 0 : 1,
                    }}
                    inputProps={{
                      style: {
                        fontSize: '16px',
                        fontFamily: 'poppins',
                        whiteSpace: 'pre-wrap', // ✅ Important to preserve formatting visually
                      },
                    }}
                  />
                  {overrideError && (
                    <Typography
                      sx={{
                        color: 'red',
                        fontSize: '12px',
                        mt: 0.5,
                        fontFamily: 'Poppins',
                      }}
                    >
                      Override confirmation is required to proceed.
                    </Typography>
                  )}
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ mb: matchessm ? 4 : 0 }}>
            <Button
              size="small"
              className={classes.ModalcancelBtn}
              sx={{ fontFamily: 'Poppins', fontSize: '16px' }}
              onClick={handleCloseStage2ConfirmModal}
              color="primary"
            >
              Close
            </Button>
            <Button
              size="small"
              className={classes.ModalnextBtn}
              sx={{
                fontFamily: 'Poppins',
                fontSize: '16px',
                cursor: 'pointer',
              }}
              onClick={handleConfirmDisableStage2}
              color="primary"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={confirmModal}
          onClose={handleCloseConfirmModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              fontFamily: 'Poppins',
              fontSize: matches450 ? '16px' : '24px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {' '}
            <Pendingwarning /> &nbsp; Confirm your selection
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <FormGroup>
                    <Grid
                      pt={2}
                      pb={2}
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                    >
                      <button className={classes.PropertyButton}>
                        STAGE 1
                      </button>
                      <br />
                    </Grid>
                    <FormControlLabel
                      control={
                        <Typography
                          sx={{
                            whiteSpace: 'nowrap',
                            cursor: 'pointer',
                            marginLeft: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                          }}
                          onClick={() => {
                            handleToggle1Change();
                          }}
                        >
                          {!acceptalloffers ? <ToggleOff /> : <ToggleOn />}
                          Unconditional Offers Only
                        </Typography>
                      }
                    />

                    <Grid
                      pt={2}
                      pb={2}
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                    >
                      <button className={classes.PropertyButton2}>
                        STAGE 2 - FINAL OFFERS
                      </button>
                    </Grid>
                    <FormControlLabel
                      sx={{ whiteSpace: 'nowrap' }}
                      control={
                        <Typography
                          sx={{
                            whiteSpace: 'nowrap',
                            cursor: 'pointer',
                            marginLeft: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                          }}
                          onClick={() => {
                            handleToggle2Change();
                          }}
                        >
                          {!unconditional ? <ToggleOff /> : <ToggleOn />}
                          Unconditional Offers Only
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      sx={{ whiteSpace: 'nowrap', marginTop: '15px' }}
                      control={
                        <Typography
                          sx={{
                            whiteSpace: 'nowrap',
                            cursor: 'pointer',
                            marginLeft: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                          }}
                          onClick={() => {
                            handleToggle3Change();
                          }}
                        >
                          {!verifiedbuyers ? <ToggleOff /> : <ToggleOn />}
                          Verified Buyers Only
                        </Typography>
                      }
                    />
                  </FormGroup>
                  {/* <Typography>Toggle 1:</Typography>
          <Switch checked={acceptalloffers} onChange={handleToggle1Change} />
          <Typography>Toggle 2:</Typography>
          <Switch checked={unconditional} onChange={handleToggle2Change} />
          <Typography>Toggle 3:</Typography>
          <Switch checked={verifiedbuyers} onChange={handleToggle3Change} /> */}
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              className={classes.ModalcancelBtn}
              sx={{ fontFamily: 'Poppins', fontSize: '16px' }}
              onClick={handleCloseConfirmModal}
              color="primary"
            >
              Back
            </Button>
            <Button
              size="small"
              className={classes.ModalnextBtn}
              sx={{
                fontFamily: 'Poppins',
                fontSize: '16px',
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
              onClick={() => {
                if (!loading) {
                  handleCloseConfirmModal();
                  Campaign('0');
                }
              }}
              // type="submit"
              type="button"
              color="primary"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={timerresetpopup} maxWidth="sm" fullWidth>
          <DialogTitle
            sx={{
              fontFamily: 'Poppins',
              fontSize: '24px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {' '}
            {lessthanstage2 ? <Redwarning /> : <Pendingwarning />} &nbsp; Timer
            Reset Value
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography>
                {lessthanstage2
                  ? 'You must select a Timer Reset value less than Stage 2 Timer'
                  : 'You have selected a Stage 2 Timer reset value greater than 6 hours, are you sure ?'}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              className={classes.ModalcancelBtn}
              sx={{ fontFamily: 'Poppins', fontSize: '16px' }}
              onClick={() => {
                setTimerresetpopup(false);
                setTimerreset(30);
                setTimer(dayjs().set('hour', 0).set('minute', 30));
              }}
              color="primary"
            >
              {lessthanstage2 ? ' Close' : 'Cancel'}
            </Button>
            {!lessthanstage2 && (
              <Button
                size="small"
                className={classes.ModalnextBtn}
                sx={{ fontFamily: 'Poppins', fontSize: '16px' }}
                onClick={() => {
                  setTimerresetpopup(false);
                }}
                color="primary"
              >
                Confirm
              </Button>
            )}
          </DialogActions>
        </Dialog>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box
            className={classes.buttonBox}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
            }}
          >
            <Button
              disabled={loading}
              variant="outlined"
              className={classes.cancelBtn}
              onClick={() => {
                onClose();
                setValue(0);
              }}
            >
              Back
            </Button>
            <Button
              disabled={loading}
              // type="submit"
              onClick={handleOpenConfirmModal}
              variant="outlined"
              className={classes.nextBtn}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              // onClick={legaldetails}
            >
              Submit
            </Button>
            {loading && (
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px', marginLeft: '10px' }}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </form>
  );
}
export const useStyles = makeStyles((theme) => ({
  noSpinArrows: {
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
      {
        '-webkit-appearance': 'none',
        margin: 0,
      },
  },
  PropertyTitle: {
    fontSize: '24px !important',
    fontWeight: '500px !important',
    fontFamily: 'Poppins !important',
    textAlign: 'left !important',
    color: '#687999 !important',
    fontStyle: 'Medium !important',
    padding: '10px 0px 10px 0px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px !important',
      fontWeight: '500px !important',
      fontFamily: 'Poppins !important',
      textAlign: 'left !important',
      fontStyle: 'Medium !important',
      padding: '10px 0px 10px 0px !important',
    },
  },
  ModalcancelBtn: {
    fontSize: '16px',
    fontFamily: 'Poppins !important',
    color: '#000 !important',
    background: '#FFFFFF !important',
    border: '1px solid #DFDFDF !important',
    borderRadius: '8px',
    textTransform: 'none !important',
    padding: '12px 87px 12px 87px',
    margin: '10px !important',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2 !important',
      border: '1px solid #6C2AD2 !important ',
    },
  },
  modalLable: {
    fontSize: '16px !important',
    color: '#000 !important',
    fontFamily: 'Poppins !important',
    fontWeight: '500px !important',
  },
  ModalnextBtn: {
    margin: '10px !important',
    backgroundColor: '#965CF0 !important',
    fontFamily: 'Poppins !important',
    color: '#FFFFFF !important',
    fontSize: '14px',
    borderRadius: '8px !important',
    textTransform: 'none !important',
    padding: '12px 87px 12px 87px',
    border: '1px solid #AF05FF !important',
    ' &:hover': {
      backgroundColor: '#965CF0 !important',
      border: '1px solid #AF05FF !important ',
    },
  },
  PropertyButton: {
    background: 'rgba(16, 211, 94, 1)',
    color: 'white',
    height: '20px',
    width: '74px',
    borderRadius: '2px',
    border: 'none',
    padding: '1px 12px 1px 12px',
    fontSize: '12px',
    fontFamily: 'Poppins',
    textAlign: 'center',
    fontWeight: '600',
  },
  stage1colour: {
    backgroundColor: 'rgba(232, 255, 232, 0.5)',
    width: '100%',
    padding: '10px',
    marginTop: '10px',
    borderRadius: '5px',
    [`@media (max-width:600px)`]: {
      marginLeft: '15px',
      width: '97%',
    },
  },
  stage2colour: {
    backgroundColor: 'rgba(255, 243, 243, 0.5)',
    width: '100%',
    padding: '20px',
    marginTop: '10px',
    borderRadius: '5px',
    [`@media (max-width:600px)`]: {
      marginLeft: '17px',
    },
  },
  PropertyButton2: {
    background: 'rgba(249, 57, 57, 1)',
    color: 'white',
    height: '20px',
    width: '177px',
    borderRadius: '2px',
    border: 'none',
    padding: '1px 12px 1px 12px',
    fontSize: '12px',
    fontFamily: 'Poppins',
    textAlign: 'center',
    fontWeight: '600',
  },
  GridRow: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  AdditionalOwner: {
    fontFamily: 'Poppins !important',
    fontSize: '16px',
    color: 'black',
    width: '351px',
    height: '48px',
    background: '#FFFFFF',
    border: '1px solid #DFDFDF',
    borderRadius: '8px',
    textTransform: 'inherit',
    padding: '12px 73px 12px 73px',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2',
      border: '1px solid #6C2AD2 !important ',
    },
    [theme.breakpoints.down('md')]: {
      width: 'auto !important',
      height: '48px',
    },
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  nextBtn: {
    margin: '10px !important',
    backgroundColor: '#965CF0 !important',
    fontFamily: 'Poppins !important',
    color: '#FFFFFF !important',
    fontSize: '16px',
    borderRadius: '8px !important',
    width: '210px',
    height: '48px',
    textTransform: 'none !important',
    padding: '12px 87px 12px 87px',
    border: '1px solid #AF05FF !important',
    ' &:hover': {
      backgroundColor: '#965CF0 !important',
      border: '1px solid #AF05FF !important ',
    },
  },
  cancelBtn: {
    fontSize: '16px',
    fontFamily: 'Poppins !important',
    color: '#000 !important',
    width: '210px',
    height: '48px',
    background: '#FFFFFF !important',
    border: '1px solid #DFDFDF !important',
    borderRadius: '8px',
    textTransform: 'none !important',
    padding: '12px 76px 12px 76px',
    margin: '10px !important',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2 !important',
      border: '1px solid #6C2AD2 !important ',
    },
  },

  menuItem: {
    fontFamily: 'Poppins !important',
    fontSize: '16px',
    fontWeight: '300',
  },
  inputLabel: {
    fontFamily: 'Poppins !important',
    marginTop: '35px',
    marginLeft: '20px',
  },
  PropertydropDown: {
    width: '290px !important',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },
}));
